import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { ROUTER_CONSTANT } from '../../constants/routerConstant';

class RemarkMenu extends Component {
    render() {
        return (
            <div className="menu space-x-7 flex overflow-auto whitespace-nowrap hide-scroll h-12">
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_ROOT_CAUSE}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_ROOT_CAUSE)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Root Cause</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_PRIORITY}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_PRIORITY)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Prioritas</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_DOCUMENT_HEADER}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_DOCUMENT_HEADER)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Dokumen Header</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_KMS_FEEDBACK}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_KMS_FEEDBACK)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>KMS Feedback</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_TICKET_FEEDBACK}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_TICKET_FEEDBACK)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Tiket Feedback</span>
                </NavLink>
                {/* <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_CHANNEL_NOTE}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_CHANNEL_NOTE)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Channel Note</span>
                </NavLink> */}
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_AUTOMATIC_MESSAGE}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_AUTOMATIC_MESSAGE)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Pesan Otomatis</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_ESCALATION}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_ESCALATION)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Eskalasi</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK_CLOSED_TICKET}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK_CLOSED_TICKET)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Closed Tiket</span>
                </NavLink>
            </div>
        );
    }
}

export default RemarkMenu;